import { SimpleGrid, StyleProps } from '@chakra-ui/react';
import { FC, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@bonusly/ds-button';

import { useMonthPickerContext } from '../month-picker-context';

export type MonthPickerFooterProps = StyleProps;

export const MonthPickerFooter: FC<MonthPickerFooterProps> = (props) => {
	const { t } = useTranslation('common');
	const { onApply, onClose } = useMonthPickerContext();
	const buttonRef = useRef<HTMLButtonElement>(null);

	useEffect(() => {
		const listener = (e: KeyboardEvent) => {
			if (e.key === 'Enter' && e.metaKey) {
				e.preventDefault();
				buttonRef.current?.click();
			}
		};

		document.addEventListener('keydown', listener);

		return () => {
			document.removeEventListener('keydown', listener);
		};
	}, []);

	return (
		<SimpleGrid columns={2} gap={2} {...props}>
			<Button colorScheme="secondary" variant="alpha" onClick={onClose}>
				{t('cancel')}
			</Button>
			<Button onClick={onApply} ref={buttonRef}>
				{t('apply')}
			</Button>
		</SimpleGrid>
	);
};
